import { render, staticRenderFns } from "./ClickJumpSignClient.vue?vue&type=template&id=255275e8&scoped=true"
import script from "./ClickJumpSignClient.vue?vue&type=script&lang=js"
export * from "./ClickJumpSignClient.vue?vue&type=script&lang=js"
import style0 from "./ClickJumpSignClient.vue?vue&type=style&index=0&id=255275e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255275e8",
  null
  
)

export default component.exports